import { Link } from 'react-router-dom';
import type { Issue } from '@/models/issue';
import { SeverityBadge, StatusBadge } from './AlarmBadge';

function timeAgo(iso: string): string {
  const diffSec = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (diffSec < 60) return `${diffSec}s`;
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h`;
  return `${Math.floor(diffSec / 86400)}d`;
}

export function IssueRow({ issue }: { issue: Issue }) {
  return (
    <Link
      to={`/i/${issue.id}`}
      className="grid items-center gap-4 py-3 px-1 border-b border-[var(--border)] hover:bg-[var(--bg-light)] transition-colors"
      style={{
        gridTemplateColumns: 'auto auto 1fr auto auto auto',
        color: 'var(--text-primary)',
        textDecoration: 'none',
      }}
    >
      <span className="font-mono text-[12px] text-[var(--text-muted)] tabular-nums w-12">
        #{String(issue.id).padStart(3, '0')}
      </span>
      <SeverityBadge severity={issue.severity} />
      <span className="text-[14px] truncate" style={{ color: 'var(--text-body)' }}>
        {issue.title}
      </span>
      <StatusBadge status={issue.status} />
      {issue.component && (
        <span className="text-[11px] font-mono text-[var(--text-muted)]">{issue.component}</span>
      )}
      <span className="text-[11px] font-mono text-[var(--text-muted)] w-10 text-right tabular-nums">
        {timeAgo(issue.created_at)}
      </span>
    </Link>
  );
}
